var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo, } from 'react';
import { AutocompleteAddress, } from './AutocompleteAddress';
import GoogleMapsModule from './GoogleMapsModule';
const useDeprecatedProps = (props) => {
    const { callbackOnFetch, filterInput, googleMapsApiKey, handleSuggestionSelection, mapModule, placeFields, searchOptions, } = props;
    useEffect(() => {
        if (!googleMapsApiKey
            && !mapModule) {
            throw new Error('AutocompleteAddress: "googleMapsApiKey" or "mapModule" prop needs to be present.');
        }
    }, [
        callbackOnFetch,
        filterInput,
        googleMapsApiKey,
        handleSuggestionSelection,
        mapModule,
        placeFields,
        searchOptions,
    ]);
    const deprecatedProps = Object.assign({}, props);
    if (Array
        .isArray(placeFields)) {
        const normalizedPlaceFields = (placeFields
            .reduce((acc, [part, type,]) => {
            acc[part] = type;
            return acc;
        }, {}));
        deprecatedProps.placeFields = normalizedPlaceFields;
    }
    return deprecatedProps;
};
// const defaultProps = {
//   ...AutocompleteAddress.defaultProps,
// };
const CompatibilityLayer = (props) => {
    const deprecatedProps = useDeprecatedProps(props);
    const { filterInput, googleMapsApiKey, handleSuggestionSelection, name, onChange, onUpdate, placeFields, searchOptions } = deprecatedProps, otherProps = __rest(deprecatedProps, ["filterInput", "googleMapsApiKey", "handleSuggestionSelection", "name", "onChange", "onUpdate", "placeFields", "searchOptions"]);
    const moduleOptions = (useMemo(() => (Object.assign(Object.assign({}, (placeFields
        && {
            placeFields,
        })), (searchOptions
        && {
            searchOptions,
        }))), [
        placeFields,
        searchOptions,
    ]));
    const googleModule = useMemo(() => (googleMapsApiKey
        ? new GoogleMapsModule(googleMapsApiKey, moduleOptions)
        : null), [
        googleMapsApiKey,
        moduleOptions,
    ]);
    const customOnUpdate = useCallback((action) => {
        var _a;
        if (action.type === 'suggestions_select'
            && handleSuggestionSelection) {
            googleModule === null || googleModule === void 0 ? void 0 : googleModule.geocode(
            // @ts-ignore 2339
            (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.place_id).then((parts) => {
                const suggestion = Object.assign(Object.assign({}, action.payload), { parts });
                const filteredSuggestion = (filterInput
                    ? filterInput(suggestion)
                    : googleModule.getSuggestionLabel(suggestion));
                onChange === null || onChange === void 0 ? void 0 : onChange({
                    target: {
                        name,
                        value: filteredSuggestion,
                    },
                });
                handleSuggestionSelection(suggestion);
            });
        }
        // Rethrow onUpdate action
        if (onUpdate) {
            onUpdate(action);
        }
    }, [
        filterInput,
        googleModule,
        handleSuggestionSelection,
        name,
        onChange,
        onUpdate,
    ]);
    // Components with 'mapModule' provided will ignore other deprecated values.
    return (deprecatedProps.mapModule
        ? (_jsx(AutocompleteAddress, Object.assign({}, deprecatedProps)))
        : (_jsx(AutocompleteAddress, Object.assign({}, otherProps, { 
            // @ts-ignore 2322
            mapModule: googleModule, name: name, onChange: onChange, onUpdate: customOnUpdate }))));
};
export { CompatibilityLayer };
